export default class LanguageUtil {
	public static getCurrentLanguage(): string {
		const activeListItem = document.querySelector<HTMLLIElement>("#selectLanguage li.active");
		const lang = activeListItem?.dataset.lang ?? "da";

		return lang;
	}
}
